<template>
  <div v-if="policy" class='employee-policy-container'>
    <table class='summary-table no-border no-padding-inbetween '>
      <tr>
        <td colspan='4' class='policy-header'>
          <div class='fl hf' style='align-items: center'>
            <p class='policy-description' style='margin-right: auto;'>{{ policy.product.description }}</p>
            <PolicyTypeBadge :policyType="policy.productType" class='mr-2' />

            <p v-if="participation.hasActiveWaiver" class='waiver'>Afstandsverklaring</p>
            <div v-else>
              <p v-if="participation.isActive" class='participation active'>Actieve Deelname</p>
              <p v-else class='participation inactive'>Geen Deelname</p>
            </div>
          </div>
        </td>
      </tr>

      <tr>
        <td>
          <p class='label'>Deelname<p>
          <p class='value mr-3'>
            {{ formatDate(participation.fromDate) }} tot {{ participation.untilDate ? formatDate(participation.untilDate) : 'onbepaald' }}</p>
        </td>
        <td align="right">
          <p class='label'>Polisnummer</p>
          <p class='value'>{{ policy.policyNumber }}</p>
        </td>

      </tr>
      <tr v-if="activeWaiverDetail">
        <td colspan='3'>
          <p class='label'>Afstandsverklaring</p>
          <p class='value'>
            {{ formatDate(activeWaiverDetail.fromDate) }} tot {{activeWaiverDetail.untilDate ? formatDate(activeWaiverDetail.untilDate) : 'onbepaald'}}
          </p>
        </td>
      </tr>
    </table>
  </div>
  <div v-else class='summary-container no-policy-found' style='text-align: center;'>
    <span>
      Deelname gevonden voor niet (meer) bestaande polis met polisnummer
      <span style='font-weight: 600;'>
        {{ participation.policyNumber}}
      </span>
    </span>
  </div>
</template>

<script>
import Compositions from '@/views/helpers/compositions';
import Helpers from '@/shared/helpers/functions';

import PolicyTypeBadge from '@/views/components/policies/PolicyTypeBadge.vue';

export default {
  name: 'EmployeePolicy',
  props: {
    participation: Object,
    policies: Array
  },
  components: {
    PolicyTypeBadge
  },
  data () {
    return {
      isOpen: false
    };
  },
  computed: {
    policy () {
      return Compositions.getPolicyFromParticipation(this.participation, this.policies);
    },
    isParticipating () {
      if (this.participation.isActive) return this.$t('yes');
      else return this.$t('no');
    },
    activeWaiverDetail () {
      return this.participation.policyParticipationDetails.find(p => p.isActiveWaiver);
    }
  },
  methods: {
    toggleOpen () {
      this.isOpen = !this.isOpen;
    },
    formatDate (date) {
      return Helpers.Dates.formatDate(date);
    },
    getParticipationClass () {
      if (this.participation.isActive) return 'participation active';
      else return 'participation inactive';
    },
    getWaiverClass () {
      if (this.participation.hasActiveWaiver) return 'waiver active';
      else return 'waiver inactive';
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/variables.scss';
.employee-policy-container {
  border-bottom: 1px solid $gray-lighten-2;
  padding-top: 10px;
  padding-bottom: 10px;
}

.policy-description {
  font-weight: 600;
  color: $primary;
}

.participation {
  padding: 4px 10px;
  width: auto;
  display: inline-block;
  border-radius: $border-radius;
  font-weight: 600;
  font-size: 0.9em;
  position: relative;

  &.active {
    color: $positive;
    background-color: $positive-lighten-2;
  }

  &.inactive {
    color: $primary;
    background-color: $gray-lighten-1;
  }
}
.waiver-indicator {
  border-radius: 50%;
  background-color: $error;
  width: 7px;
  height: 7px;
  display: block;
}
.waiver {
  padding: 4px 10px;
  width: auto;
  display: inline-block;
  border-radius: $border-radius;
  font-weight: 600;
  font-size: 0.9em;
  position: relative;
  color: $error;
  background-color: $error-lighten-2;
  color: $error;
}

.no-policy-found {
  background-color: $error-lighten-1;
  border: 1px solid $error-lighten-1;
  color: $error;
  padding: 20px;

  span {
    color: $error;
  }
}
</style>
